// extracted by mini-css-extract-plugin
var _1 = "DocumentMoveToActionModal-moduleactions__iySnV FormActions-moduleFormActions__WNNEs";
var _2 = "DocumentMoveToActionModal-modulecontent__izfPx";
var _3 = "DocumentMoveToActionModal-moduleempty__qPe8y";
var _4 = "DocumentMoveToActionModal-modulefolders__qZrbO";
var _5 = "DocumentMoveToActionModal-modulelist__ypkZM";
var _6 = "DocumentMoveToActionModal-modulesearchWrapper__TQ3vm";
export { _1 as "actions", _2 as "content", _3 as "empty", _4 as "folders", _5 as "list", _6 as "searchWrapper" }
